;(function () {
	const initMegaSubmenu = (header) => {
		const megaSubmenuLinks = header.querySelectorAll(
			'.list-menu--megasubmenu'
		)
		if (!megaSubmenuLinks || !megaSubmenuLinks.length) return
		megaSubmenuLinks.forEach((link) => {
			const tabs = link.querySelectorAll('.mega-submenu__tab')
			const submenus = link.querySelectorAll('.mega-submenu__submenu')
			const onToggle = (event) => {
				const tab = event.target
				if (!tab || !tab.classList.contains('mega-submenu__tab')) return
				const tabId = tab.dataset.tabId
				tabs.forEach((tab) => {
					tab.classList.remove('active')
				})
				tab.classList.add('active')
				submenus.forEach((submenu) => {
					submenu.classList.remove('active')
					if (submenu.dataset.tabId === tabId) {
						submenu.classList.add('active')
					}
				})
			}
			tabs.forEach((tab) => {
				tab.addEventListener('click', onToggle)
				tab.addEventListener('mouseenter', onToggle)
			})
		})
	}

	const loadMegaMenuImages = (root) => {
		if (!root) return
		root.querySelectorAll('[data-mega-menu-lazy-image]').forEach((image) => {
			if (image.dataset.megaMenuLazyLoaded === 'true') return
			if (image.dataset.srcset) {
				image.srcset = image.dataset.srcset
				image.removeAttribute('data-srcset')
			}
			if (image.dataset.src) {
				image.src = image.dataset.src
				image.removeAttribute('data-src')
			}
			image.dataset.megaMenuLazyLoaded = 'true'
		})
	}

	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search.isOpen) {
				search.close()
			}
		})

		let vh = window.innerHeight * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`,
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					loadMegaMenuImages(link)
					if (link.classList.contains('list-menu--tabs')) {
						const megaMenu = link.querySelector('.mega-menu') || link.querySelector('.mega-submenu');
						const headerMain = header.querySelector('.header')
						if (!megaMenu || !headerMain) return
						const linkPosition = link.getBoundingClientRect().x
						megaMenu.style.left = `${linkPosition}px`
					}
					link.classList.add('list-menu--megamenu-visible')
					if (
						header.classList.contains('color-background-3') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.remove('color-background-3')
					}

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
		})

		if (header.dataset.megaMenuLazyImagesBound !== 'true') {
			const loadActivatedMenuImages = (event) => {
				const activatedMenu = event.target.closest('.list-menu--megamenu, header-drawer')
				if (activatedMenu) loadMegaMenuImages(activatedMenu)
			}

			header.addEventListener('focusin', loadActivatedMenuImages)
			header.addEventListener('touchstart', loadActivatedMenuImages, { passive: true })
			header.addEventListener('click', loadActivatedMenuImages)
			header.dataset.megaMenuLazyImagesBound = 'true'
		}

		menu.addEventListener('mouseleave', (e) => {
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})

		document.body.addEventListener('mousedown', function () {
			document.body.classList.add('mouse-focus')
		})

		document.body.addEventListener('keydown', function (e) {
			if (e.key === 'Tab') {
				document.body.classList.remove('mouse-focus')
			}
		})

		const addBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains('color-background-3') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.remove('color-background-3')
					}
				}
			})

			headerObserver.observe(header)
		}

		const removeBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains('color-background-1') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.add('color-background-3')
					}
				}
			})

			headerObserver.observe(header)
		}

		header.addEventListener('mouseenter', addBackground)

		header.addEventListener('focus', addBackground)

		header.addEventListener('focusin', addBackground)

		header.addEventListener('mouseleave', removeBackground)

		header.addEventListener('focusout', removeBackground)

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector('.mega-menu__list-item--children')
			const megaMenuLinks = document.querySelectorAll('.mega-menu__list-item')
			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add('mega-menu__list-item--opacity')
				})
				megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--opacity')
				megaMenuLinkWithSubmenu.classList.add('mega-menu__list-item--visible')
			}
			megaMenuLinks.forEach((item) => {
				if (item.dataset.megaMenuListBound === 'true') return
				item.dataset.megaMenuListBound = 'true'

				const siblings = Array.from(item.parentElement?.children || []).filter((el) => el !== item)
				const activate = () => {
					if (megaMenuLinkWithSubmenu) {
						megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--visible')
					}
					item.classList.remove('mega-menu__list-item--opacity')
					siblings.forEach((sibling) => sibling.classList.add('mega-menu__list-item--opacity'))
				}
				const reset = () => {
					siblings.forEach((sibling) => sibling.classList.remove('mega-menu__list-item--opacity'))
				}

				item.addEventListener('mouseenter', activate)
				item.addEventListener('focus', activate)
				item.addEventListener('focusin', activate)
				item.addEventListener('mouseleave', reset)
				item.addEventListener('focusout', reset)
			})
		}

		const megaMenuSublinks = () => {
			document.querySelectorAll('.mega-menu--list .mega-menu__submenu-item').forEach((item) => {
				if (item.dataset.megaMenuSubmenuBound === 'true') return
				item.dataset.megaMenuSubmenuBound = 'true'

				const parent = item.parentElement
				const relatedItems = Array.from(parent?.parentElement?.children || [])
					.filter((el) => el !== parent)
					.flatMap((el) => Array.from(el.querySelectorAll('.mega-menu__submenu-item')))
				const activate = () => {
					item.classList.remove('mega-menu__submenu-item--opacity')
					relatedItems.forEach((relatedItem) => relatedItem.classList.add('mega-menu__submenu-item--opacity'))
				}
				const reset = () => {
					relatedItems.forEach((relatedItem) => relatedItem.classList.remove('mega-menu__submenu-item--opacity'))
				}

				item.addEventListener('mouseenter', activate)
				item.addEventListener('focusin', activate)
				item.addEventListener('mouseleave', reset)
				item.addEventListener('focusout', reset)
			})
		}

		const megaMenuTabs = () => {
			const tabs = document.querySelectorAll('.mega-menu__tab-wrapper')
			tabs[0]?.classList.add('mega-menu__tab-wrapper--active')

			tabs.forEach((tab) => {
				if (tab.dataset.megaMenuTabBound === 'true') return
				tab.dataset.megaMenuTabBound = 'true'

				const activate = () => {
					tabs.forEach((item) => item.classList.remove('mega-menu__tab-wrapper--active'))
					tab.classList.add('mega-menu__tab-wrapper--active')
				}

				tab.addEventListener('mouseenter', activate)
				tab.addEventListener('focus', activate)
				tab.addEventListener('focusin', activate)
			})
		}

		megaMenuListLinks()
		megaMenuSublinks()
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
			!main.querySelectorAll('.shopify-section')[0]?.classList.contains('not-margin')
		) {
			header.classList.add('color-background-1', 'color-background-3')
			if (breadcrumbs) {
				breadcrumbs.classList.add('color-background-3')
			}
		}

		initMegaSubmenu(header);
	}

	header()

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)
})()
